var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid"},[_c('div',{staticClass:"inner-wap"},_vm._l((_vm.question.get('characters')),function(c){return _c('div',{key:c,staticClass:"character",class:{ selected: _vm.answerCharacters.indexOf(c) >= 0 }},[_vm._v("\n      "+_vm._s(c)+"\n    ")])}))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7577856","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quiz/quiz_question_result/QuizQuestionResultGridView.vue
// module id = 1642
// module chunks = 0